import React, { useState } from "react";

// Encabezado ordenable. Misma API de siempre: headers [{ name, field, sortable }] y onSorting(field, order).
const Header = ({ headers, onSorting }) => {
    const [sortingField, setSortingField] = useState("");
    const [sortingOrder, setSortingOrder] = useState("asc");

    const onSortingChange = (field) => {
        const order =
            field === sortingField && sortingOrder === "asc" ? "desc" : "asc";

        setSortingField(field);
        setSortingOrder(order);
        onSorting(field, order);
    };

    return (
        <thead>
            <tr>
                {headers.map(({ name, field, sortable }) => {
                    const activo = sortable && sortingField === field;
                    const icono = !activo ? "fas fa-sort" : sortingOrder === "asc" ? "fas fa-sort-up" : "fas fa-sort-down";
                    return (
                        <th
                            key={name}
                            className={[sortable ? "th-sortable" : "", activo ? "th-sorted" : ""].filter(Boolean).join(" ")}
                            onClick={() => (sortable ? onSortingChange(field) : null)}
                            title={sortable ? "Ordenar" : undefined}
                        >
                            {name}
                            {sortable ? <i className={`${icono} th-sort-icon`} /> : null}
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
};

export default Header;
